module.exports = __webpack_public_path__ + "media/images/front/programs/02-3ef4fe2dd39b045ce08c565742356c71.jpg";